import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from '../../constants/urls';
import { getUtmData } from '../../utils/adsTracking';
import { AUTH_CHANGED_EVENT, pushData, pushEvent } from '../../utils/dataLayer';

const headers = () => ({ Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` });

// Variáveis globais do site antigo (footer-pixels.htm): environment, utm,
// user.type (registered_user | guest), user e saldo de cashback.
const DataLayerBootstrap = () => {
  const { pathname } = useLocation();
  const staticPushed = useRef(false);
  const lastToken = useRef(undefined);

  useEffect(() => {
    if (staticPushed.current) return;
    staticPushed.current = true;
    pushData({ environment: process.env.REACT_APP_ENVIRONMENT || (process.env.NODE_ENV === 'production' ? 'prod' : 'dev') });
    const { source, campaign } = getUtmData();
    pushData({ utm: { campaign, source } });
  }, []);

  useEffect(() => {
    const syncUser = async () => {
      const token = localStorage.getItem('token');
      if (token === lastToken.current) return;
      lastToken.current = token;

      if (!token) {
        pushData({ user: { type: 'guest' } });
        return;
      }

      try {
        const { data: user } = await axios.get(`${BASE_URL}/pbw-meucupom-users`, {
          params: { token },
          headers: headers(),
        });
        if (!user?.id) {
          pushData({ user: { type: 'guest' } });
          return;
        }

        pushData({ user: { type: 'registered_user' } });
        // só campos não sensíveis: a resposta da API inclui dados pessoais e credenciais
        pushData({ user: { id: user.id } });

        const { data: cash } = await axios.get(`${BASE_URL}/cashback/count`, {
          params: { userId: user.id },
          headers: headers(),
        });
        if (!cash || typeof cash !== 'object') return;

        pushData({
          user: {
            cashbackAvailableAmount: cash.cashback,
            cashbackPendingAmount: cash.pending,
            cashbackPaidAmount: cash.paid,
          },
        });
        pushEvent('cashbackLoaded');
      } catch {
        lastToken.current = undefined; // tenta de novo na próxima navegação
      }
    };

    syncUser();
    window.addEventListener(AUTH_CHANGED_EVENT, syncUser);
    return () => window.removeEventListener(AUTH_CHANGED_EVENT, syncUser);
  }, [pathname]);

  return null;
};

export default DataLayerBootstrap;
